import React, { useEffect, useRef, useState } from "react";

import $ from "jquery";
import { FiCalendar } from "react-icons/fi";
import moment from "moment";

import "daterangepicker";

import "daterangepicker/daterangepicker.css";

const DateRangePicker = ({ onDateChange, startDate, endDate }) => {
  const pickerRef = useRef();

  // LABEL STATE
  const [label, setLabel] = useState("");

  useEffect(() => {
    const $picker = $(pickerRef.current);

    // REMOVE OLD
    if ($picker.data("daterangepicker")) {
      $picker.data("daterangepicker").remove();
    }

    // DEFAULT DATES
    const start = startDate ? moment(startDate) : moment().startOf("month");

    const end = endDate ? moment(endDate) : moment().endOf("month");

    // INITIAL LABEL
    setLabel(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);

    // CALLBACK
    const cb = (start, end) => {
      // UPDATE LABEL
      setLabel(
        `${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`,
      );

      // PARENT CALLBACK
      if (onDateChange) {
        onDateChange(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
      }
    };

    // INIT PICKER
    $picker.daterangepicker(
      {
        startDate: start,

        endDate: end,

        autoUpdateInput: false,

        showDropdowns: true,

        opens: "left",

        linkedCalendars: false,

        alwaysShowCalendars: true,

        ranges: {
          Today: [moment(), moment()],

          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],

          "Last 7 Days": [moment().subtract(6, "days"), moment()],

          "Last 30 Days": [moment().subtract(29, "days"), moment()],

          "This Month": [moment().startOf("month"), moment().endOf("month")],

          "Last Month": [
            moment().subtract(1, "month").startOf("month"),

            moment().subtract(1, "month").endOf("month"),
          ],
          "Last 1 Year": [
            moment().subtract(1, "year").startOf("day"),
            moment().endOf("day"),
          ],
        },
      },

      cb,
    );
    setTimeout(() => {
      $(".applyBtn").css({
        background: "#016fa6",
        borderColor: "#016fa6",
        color: "#fff",
      });

      $(".applyBtn").hover(
        function () {
          $(this).css({
            background: "#016fa6",
            borderColor: "#016fa6",
          });
        },
        function () {
          $(this).css({
            background: "#016fa6",
            borderColor: "#016fa6",
          });
        },
      );
    }, 0);
    setTimeout(() => {
      $(".cancelBtn").css({
        background: "transparent",
        border: "none",
        boxShadow: "none",
        color: "#000",
      });
    }, 0);
    // CLEANUP
    return () => {
      if ($picker.data("daterangepicker")) {
        $picker.data("daterangepicker").remove();
      }
    };
  }, [startDate, endDate, onDateChange]);

  return (
    <div
      ref={pickerRef}
      style={{
        background: "#fbf9f9",
        cursor: "pointer",
        padding: "0 10px",
        border: "1px solid #d1d5db",
        borderRadius: "2px",
        minWidth: "50px",
        height: "30px",
        fontSize: "13px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
        color: "#334155",
        boxSizing: "border-box",
      }}
    >
      {/* LEFT SIDE */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            color: "#0f172a",
          }}
        >
          {label}
        </span>
      </div>

      {/* RIGHT ICON */}
      <FiCalendar
        style={{
          color: "#64748b",
          fontSize: "14px",
        }}
      />
    </div>
  );
};

export default DateRangePicker;
